import React from 'react';
import { Paper, Stack, Typography } from '@mui/material';
import { Inventory2 as InventoryIcon } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import MaterialsSection from '../SiteSettingsPage/MaterialsSection';
import MaterialDocumentsSection from './MaterialDocumentsSection';
import ConsumableNoteCard from '../../components/ConsumableNoteCard';
import ProjectPageShell from '../ProjectDashboardPage/ProjectPageShell';

/**
 * 자재 관리 전용 페이지.
 *
 * 사이드바 '자재' 메뉴 및 개요의 자재 위젯 "자재 관리" 버튼에서 진입한다.
 * 좌측 사이드 패널을 그대로 유지하기 위해 공통 `ProjectPageShell` 안에 들어간다.
 */
const SiteMaterialsPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const projectIdNum = projectId ? Number(projectId) : NaN;

  return (
    <ProjectPageShell
      projectId={projectId ?? ''}
      activeSection="materials"
      breadcrumbExtra={
        <Typography
          color="text.primary"
          sx={{ display: 'flex', alignItems: 'center', fontWeight: 700 }}
        >
          <InventoryIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          자재 관리
        </Typography>
      }
      hideSettingsButton
    >
      {Number.isFinite(projectIdNum) ? (
        <Stack spacing={3}>
          <MaterialsSection projectId={projectIdNum} />
          {/* 소모품 — 전체 소모품 화면(/consumables)의 현장 카드와 같은 내용이다.
              회사 재고와 맞춰 보려면 그 화면을 쓴다. */}
          <ConsumableNoteCard
            projectId={projectIdNum}
            title="소모품"
            subtitle="이 현장에서 쓰는 중인 소모품의 품명·수량입니다."
            quantityLabel="사용중"
          />
          <MaterialDocumentsSection projectId={projectIdNum} />
        </Stack>
      ) : (
        <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
          <Typography color="error">유효하지 않은 프로젝트 ID</Typography>
        </Paper>
      )}
    </ProjectPageShell>
  );
};

export default SiteMaterialsPage;
